import { useParams } from "react-router-dom";
import { useEffect } from "react";
import InputForm from "../components/inputform";
import { Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
    deleteDeviceData,
    getLastDeviceData,
  pushDeviceData,
  selectDeviceInfoData,
} from "../../store/deviceData/deviceDataSlice";

export default function Dtail() {
  const { device, prdId } = useParams() as {
    device: string;
    prdId: string;
  };
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const deviceInfoData = useAppSelector(selectDeviceInfoData);
  
  useEffect(() => {
    dispatch(getLastDeviceData({ deviceType:device, prdId }));
  }, []);
  const confirmAction = (message: string, action: () => void) => {
    if (window.confirm(message)) {
      action();
    }
  };
  const pushData = () => {console.log(deviceInfoData)
      console.log(deviceInfoData?.prd_id)
    confirmAction(
      `시리얼넘버 ${device} ${deviceInfoData?.prd_id} 수정하시겠습니까?`,
      () => dispatch(pushDeviceData({ deviceType:device, deviceInfoData })).then(()=>{
        dispatch(getLastDeviceData({deviceType:device,prdId:'0'}));
      })
    );

  };
  const removeData = () => {
    confirmAction(
        `시리얼넘버 ${device} ${deviceInfoData?.prd_id} 정말 삭제하시겠습니까?`,
        () => dispatch(deleteDeviceData({ deviceType:device, deviceInfoData })).then(()=>{
          dispatch(getLastDeviceData({deviceType:device,prdId:'0'}));
        })
      );
  };

  return (
    <div>
      <Row>
        <Col>
          <button
            onClick={() => {
              if (device && prdId) {
                dispatch(getLastDeviceData({ deviceType: device, prdId }));
              }
            }}
          >
            새로고침
          </button>
        </Col>
        <Col>
          <h2>Device: {device}</h2>
        </Col>
        <Col>
          <button onClick={() => navigate(-1)}>뒤로가기</button>
        </Col>
      </Row>
      {<InputForm />}
      <Row>
        <Col>
          <Button onClick={() => pushData()}>수정</Button>
        </Col>

        <Col>
          <Button onClick={() => removeData()}>삭제</Button>
        </Col>
      </Row>
    </div>
  );
}
